import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { computed } from '@nuxtjs/composition-api'
import { ICartItem } from './../model/types'
import { useMenuModel } from '../model'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuCartPrice',
  props: {
  cartItems: {
    type: Array as PropType<ICartItem[]>,
    required: true,
    default: () => {}
  },
  currencyIcon: {
    type: String as PropType<string>,
    required: false,
    default: ''
  }
},
  setup(__props) {

const props = __props



const menuModel = useMenuModel()

const totalSum = computed(() => {
  const totalSum = props.cartItems
    .filter((item: ICartItem) => {
      // Исключаем блюда, которые полностью в стоп-листе
      if (menuModel.unavailableDishIds.has(item.id)) {
        return false
      }
      // Исключаем блюда с модификаторами в стоп-листе (полностью исключаем, т.к. пользователь должен изменить)
      const cartItem = item as any
      const cartItemId = cartItem.cartItemId || String(item.id)
      const unavailableModifiers = menuModel.unavailableModifierIds.get(cartItemId)
      if (unavailableModifiers && unavailableModifiers.size > 0) {
        return false
      }
      return true
    })
    .reduce((acc: number, item: ICartItem) => {
      acc = acc + (item.price * item.inCart)
      return acc
    }, 0)
  return totalSum / 100
})

return { __sfc: true,props, menuModel, totalSum }
}

})